import React, {useEffect, useState} from "react";
import {Button, Col, Row} from "react-bootstrap";
import {RequireAuth} from "Components/Security/RequireAuth";
import {DefaultContainer} from "Views/Shared/DefaultContainer";
import {useNavigate, useParams} from "react-router-dom";
import {Notificator} from "Services/Notificator/Notificator";
import {useMutation, useQuery} from "react-query";
import {useAppDispatch} from "hooks";
import {appLoading} from "Store/loadingSlice";
import {getConfig, updateConfig, uploadConfigFile} from "../../Api/Query/ConfigQuery";
import {ROUTE_PATHS} from "../../Config/Router/Routes";
import {DropzoneFile, FileUpload} from "../../Components/FileUpload/FileUpload";
import {ErrorMessageBuilder} from "../../Services/Notificator/ErrorMessageBuilder";
import {AdminConfigValuePreview} from "./AdminConfigValuePreview";

export interface Props {
    files?: DropzoneFile[]
}

export const AdminConfigEdit: React.FC<Props> = (props) => {

    const TYPES_WITH_UPLOAD = ['file','image']

    const {id} = useParams()
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const [files, setFiles] = useState<DropzoneFile[]>(props.files ?? [])

    const [entity, setEntity] = useState<any>({
        id: null,
        value: null,
        type: ''
    })

    const setAppLoading = (loading: boolean, text: string = ''): void => {
        dispatch(
            appLoading({
                value: loading,
                text: text
            })
        )
    }

    const update = useMutation({
        mutationKey: [],
        mutationFn: () => updateConfig(entity.id, entity.value),
        onSuccess: () => {
            Notificator.success('Se ha editado correctamente')
            navigate(ROUTE_PATHS.ADMIN_CONFIG_LIST)
        },
        onError: () => {
            Notificator.error('Se ha producido un error al editar')
            navigate(ROUTE_PATHS.ADMIN_CONFIG_LIST)
        }
    })

    const uploadMutation = useMutation({
        mutationFn: (file: any) => uploadConfigFile(file, entity.id),
        onMutate: (body: any) => {
            setAppLoading(true, `Subiendo archivo: ${body.file.name} ...`)
        },
        onSuccess: () => {
            setAppLoading(false)
            Notificator.success('Los cambios se han guardado correctamente.', 'Éxito')
            navigate(ROUTE_PATHS.ADMIN_CONFIG_LIST)
        },
        onError: (error: any) => {
            setAppLoading(false)

            const notificationMessage = ErrorMessageBuilder.create(error)
            Notificator.error(notificationMessage, 'Error')
        }
    })

    const onSave = () => {
        if(TYPES_WITH_UPLOAD.includes(entity.type) && files.length > 0) {
            console.log(files)
            uploadMutation.mutateAsync(files[0]).then(r => {
                console.log('uploaded', r)
            })
        }else if(!TYPES_WITH_UPLOAD.includes(entity.type)){
            update.mutate()
        }
    }

    const query = useQuery({
        enabled: false,
        queryKey: ['getConfig', id],
        queryFn: () => getConfig(id ?? '-1'),
        onSuccess: (response: any) => {
            console.log(response.data)
            setEntity(response.data._result)
        },
        onError: () => {
            Notificator.error('Se ha producido un error al cargar los datos.')
        }
    })

    useEffect(() => {
        query.refetch()
    }, []);

    useEffect(() => {
        dispatch(appLoading({value: query.isLoading, text: 'Cargando'}))
    }, [query.isLoading])

    useEffect(() => {
        dispatch(appLoading({value: update.isLoading, text: 'Cargando'}))
    }, [update.isLoading])

    useEffect(() => {
        dispatch(appLoading({value: query.isRefetching, text: 'Cargando'}))
    }, [query.isRefetching])

    return (
        <RequireAuth>
            <DefaultContainer>

                <Col>

                    <Row>
                        <Col>
                            <h1 className={"pb-4"}>Detalle de configuracion</h1>
                        </Col>

                    </Row>

                    <Row>
                        <Col xs={12}>
                            <p><strong>Nombre:</strong> {entity.id}</p>
                            <p><strong>Valor:</strong></p>

                            {
                                ['date','text','array'].includes(entity.type) && <>
                                <textarea
                                    className={"form-control w-100"}
                                    rows={10}
                                    onChange={(e) => setEntity({...entity, value: e.target.value})}
                                    value={entity.value}
                                ></textarea>
                                </>
                            }

                            {
                                TYPES_WITH_UPLOAD.includes(entity.type) && <>
                                    <AdminConfigValuePreview entity={entity} />

                                    <p><strong>Subir archivo:</strong></p>
                                    <FileUpload
                                        onChange={(files) => setFiles(files)}
                                        maxFiles={1}
                                        allowedFilesText={"* Archivos permitidos: JPG, JPEG, PNG y PDF."}
                                    />
                                </>
                            }

                            <br/>
                            <Button
                                className={"purple-btn btn-sm"}
                                onClick={() => onSave()}
                            >Guardar</Button>
                        </Col>
                    </Row>

                </Col>

            </DefaultContainer>
        </RequireAuth>
    )
}
